<template>
    <div class="pt-5 pb-2 my-5 px-3 h2 bg-white shadow lyrics-container-parent fadeInUp">
        <div v-if="getReadyToStart" id="lyrics-container">
            <div id="show-line-to-type" v-html="getEachLine"></div>
            <div id="next-line" class="py-3 text-muted h4" v-html="getNextLine"></div>
            <div id="input-container-to-type" class="mt-5">
                <input id="lyrics-input" @keyup.enter="goToNextLine()" type="text" v-model="typedLyricLine"
                placeholder="Start Typing the Lyrics" autofocus>
            </div>
            <div id="show-other-details" class="mt-4 mb-2 h5 text-right">
                <span>~{{getTypingStats.wpm}} WPM</span> &bullet; <span>{{getLinesLeft}} lines left</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Lyrics",
    props: {
        lyricsText: String
    },
    data: () => {
        return {
            lyricsSplitted: [],
            lyricsTyped: [],
            lyricsIndex: 0,
            typedLyricLine: "",
            readyToStart: false,
            // Data related to typing stats
            wordsTypedTillLastMin: 0,
            typingStats: {
                startTime: null,
                endTime: null,
                wpm: "0",
            }
        }
    },
    methods: {
        parseLyrics() {
            let parsed = this.lyricsText.replace("\r", "");
            this.lyricsSplitted = parsed.split("\n").filter(
                sentence => sentence.replace(/\r|[ ]{1,}/g, "") != "" && sentence.replace(/^[ ]{1,}/g, "")[0] != "["
            );
            this.lyricsSplitted = this.lyricsSplitted.map(s => s.replace(/^[ ]{1,}|[ ]{1,}$/g, ""));
            this.readyToStart = true;
        },
        getOneLine() {
            return this.lyricsSplitted[this.lyricsIndex];
        },
        goToNextLine() {
            if (this.lyricsIndex == this.lyricsSplitted.length - 1) {
                this.typingStats["endTime"] = Date.now();
                this.calculateAccuracy();
                this.calculateFinalWpm();
                this.readyToStart = false;
                this.$emit("completed", this.typingStats);
                return;
            }
            this.lyricsTyped.push(this.typedLyricLine.slice(0, this.lyricsSplitted[this.lyricsIndex].length));
            this.typedLyricLine = "";
            this.lyricsIndex++;
        },
        wpmCalculatorHandler() {
            // Method to handle wpm calculation.
            setInterval(() => this.calculateWpm(), 5000);
        },
        calculateWpm() {
            // Calculate WPM, method needs to be called every one minute
            let currentWords = 0;
            this.lyricsTyped.forEach(sentence => {
                currentWords += sentence.split(" ").length;
            });
            this.typingStats["wpm"] = (currentWords - this.wordsTypedTillLastMin) * 12;
            this.wordsTypedTillLastMin = currentWords;
        },
        calculateAccuracy() {
            /**
             * We will go through each letter in the typed array and keep
             * track of all the wrong letters.
             * 
             * The percentage will be the amount of wrong letters / typed
             * letters multiplied by 100.
             * 
             * The accuracy will be 100 - (the above calculated value).
             * 
             * Before continuing, we need to split the array's of sentences
             * , replace all the spaces and break them into characters, only
             * then we can calculate proper union and intersection.
             */
            let actualChars = this.lyricsSplitted.join(" ").replace(" ", "").split("");
            const typedChars = this.lyricsTyped.join(" ").replace(" ", "").split("");
            // We cannot just consider the whole lyrics in case the user was not
            // able to type em all. So we need to slide the whole lyrics and then
            // work on it.
            actualChars = actualChars.slice(0, typedChars.length);

            // Get an array with all the correct letters
            const correctLetters = typedChars.filter((el, Index) => el == actualChars[Index]);

            const similarity = (correctLetters.length / typedChars.length) * 100;
            this.typingStats["accuracy"] = Math.round((similarity + Number.EPSILON) * 100) / 100;
        },
        calculateFinalWpm() {
            // Calculate the final WPM based on the words written
            const totalMinsTaken = Math.floor(this.typingStats["endTime"] - this.typingStats["startTime"]) / (1000 * 60);
            let wordsWritten = 0;
            this.lyricsTyped.forEach(s => {wordsWritten += s.split(" ").length});
            this.typingStats["totalMinsTaken"] = Math.round((totalMinsTaken + Number.EPSILON) * 100) / 100;
            this.typingStats["finalWpm"] = Math.floor(wordsWritten / totalMinsTaken);
        }
    },
    computed: {
        getEachLine() {
            return this.getOneLine();
        },
        getReadyToStart() {
            return this.readyToStart;
        },
        getLinesLeft() {
            return this.lyricsSplitted.length - this.lyricsIndex;
        },
        getNextLine() {
            return this.lyricsSplitted[this.lyricsIndex + 1];
        },
        getTypingStats() {
            return this.typingStats;
        }
    },
    mounted() {
        this.typingStats["startTime"] = Date.now();
        this.parseLyrics();
        this.wpmCalculatorHandler();
    },
    updated() {
        document.getElementById("lyrics-input").focus();
    }
}
</script>

<style lang="scss">
    #lyrics-container {
        #input-container-to-type {
            input {
                width: 100%;
                padding: 10px 5px;
                box-shadow: none;
                border: 2px solid #00BCD4; 
                border-radius: 7px;

                &:focus, &:hover {
                    outline: none;
                }
            }
        }
    }

    .lyrics-container-parent {
        border-radius: 7px;
    }
</style>